"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const IntegrationAppIntegrationContext = createContext({
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type... Remove this comment to see the full error message
  integrationId: null
});
IntegrationAppIntegrationContext.displayName = "IntegrationAppIntegrationContext";
function useIntegrationAppIntegration() {
  return useContext(IntegrationAppIntegrationContext);
}

export { IntegrationAppIntegrationContext, useIntegrationAppIntegration };
